import styled from "styled-components";
import { MaterialIcon } from "../shared/MaterialIcon";

export const ArchiveDropZone = ({isActive}) => {
    return (
        <StyledArchiveDropZone id="archiveZone" className={isActive ? "isActive" : null}>
            <div>
                <MaterialIcon
                    name='inventory_2'
                    color={({theme}) => theme.colors.errorForeground}
                    weight={300}
                />
            </div>
            <span>
                Slipp her for å arkivere.
            </span>
        </StyledArchiveDropZone>
    )
}

const StyledArchiveDropZone = styled.div`
    position: absolute;
    bottom: ${({theme}) => theme.spacing.xxl};
    left: 50%;
    transition-duration: 220ms;
    transform: translateX(-50%) translateY(calc(200% + ${({theme}) => theme.spacing.sm}));

    &.isActive
    {
        transform: translateX(-50%) translateY(0);
    }
    
    display: flex;
    align-items: center;
    gap: ${({theme}) => theme.spacing.md};
    border: 1px solid red;
    padding: ${({theme}) => theme.spacing.sm};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    border: 1px solid ${({theme}) => theme.colors.errorForeground};
    color: ${({theme}) => theme.colors.errorForeground};
    background-color: ${({theme}) => theme.colors.neutralPrimaryBackground};
    font-weight: 500;
    filter: ${({theme}) => 'drop-shadow(0 4px 4px rgba(' + theme.colors.neutralSecondaryForegroundRGB + ', 0.15))'};

    > div
    {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${({theme}) => theme.spacing.sm};
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        background: ${({theme}) => theme.colors.errorBackground};
        
        svg
        {
            color: ${({theme}) => theme.colors.errorForeground};
            height: ${({theme}) => theme.iconSize.sm};
            width: ${({theme}) => theme.iconSize.sm};
        }
    }

`